import { APP_BASE_URL } from "../../config/api";
import { authFetch } from "../../utils/api";

// Admin AI usage APIs now live under /api/admin
const BASE_URL = `${APP_BASE_URL}/api/admin/ai_uses_list`;

export async function listAiUses(limit = 100, offset = 0, date = "") {
  let url = `${BASE_URL}?limit=${limit}&offset=${offset}`;
  try {
    // Add date parameter if provided
    if (date) {
      url += `&date=${encodeURIComponent(date)}`;
    }

    const res = await authFetch(url);

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(
        `Failed to fetch AI usage records: ${res.status} ${res.statusText}`,
      );
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching AI usage records:", error);
    throw error;
  }
}

export async function getAiUsageSummary(date = "") {
  let url = `${APP_BASE_URL}/api/admin/ai_uses_summary`;
  try {
    if (date) {
      url += `?date=${encodeURIComponent(date)}`;
    }
    const res = await authFetch(url);
    if (!res.ok) {
      const text = await res.text();
      throw new Error(
        `Failed to fetch AI usage summary: ${res.status} ${res.statusText} ${text}`,
      );
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching AI usage summary:", error);
    throw error;
  }
}
